import type { RefObject } from 'react';

/**
 * Adds a new file to zendesk and updates the state with the new token received.
 * @param {RefObject<HTMLInputElement>} inputReference - Reference to the input type file
 * @param {React.Dispatch<React.SetStateAction<File[] | null>>} setFiles - Sets a new file for files
 */

export const onChangeHandler = (
  inputReference: RefObject<HTMLInputElement>,
  setFiles: React.Dispatch<React.SetStateAction<File[] | null>>,
) => {
  const inputFiles =
    (inputReference.current && inputReference.current.files) || null;

  if (inputFiles) {
    const inputFile = inputFiles[0];
    if (inputFile !== undefined) {
      setFiles(prevFiles => {
        const prev = prevFiles || [];
        return [...prev, inputFile];
      });
    }
  }
};
